module.exports = __webpack_public_path__ + "static/img/jg.061dd8a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/jg.png
// module id = picz
// module chunks = 1